<template>
  <div
    class="network-flow-used-record tb"
    v-if="funcView.list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            placeholder="IMIS/ICCID"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter('')"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('dms_networkFlowUsedRecord.yue_fen')">
          <el-date-picker
            v-model="formSearch.monthrange"
            type="monthrange"
            :range-separator="$t('dms_networkFlowUsedRecord.zhi')"
            :start-placeholder="$t('dms_networkFlowUsedRecord.kai_shi_yue_fen')"
            :end-placeholder="$t('dms_networkFlowUsedRecord.jie_shu_yue_fen')"
            :picker-options="{'firstDayOfWeek': 1}"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 库存方 -->
        <el-form-item :label="$t('dms_networkFlowUsedRecord.gong_ying_shang')">
          <el-input v-model="formSearch.supplierName" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['month']"
      >
        <template v-slot:month="scope">
          {{fixMonth(scope.row)}}
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';

export default {
  name: 'networkFlowUsedRecord',
  mixins: [resetFormSearchMixins],
  components: {},
  data() {
    return {
      tableCode: 'sim_network_flow_used_record',
      dialogVisible: false,
      dialogModel: {},
      productId: '',
      productTotal: 0,

      formSearch: {
        search: '',
        supplierName: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        monthrange: []
      },
      tableList: [],
      totalRows: null,
      link: null,
    };
  },
  activated: function () {
    this.getTableList();
  },
  computed: {
    monthRangeFormat() {
      const monthrange = this.formSearch.monthrange;
      if (monthrange && monthrange.length) {
        const endDate = this.getNextMonthDate(monthrange[1]);
        const start = this.$momentWorld(monthrange[0], 'YYYY-MM-DD HH:mm:ss');
        const end = this.$momentWorld(endDate, 'YYYY-MM-DD HH:mm:ss');
        return [start, end];
      }

      return [];
    }
  },
  watch: {
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableColumn();
  },
  methods: {
    getNextMonthDate(date) {
      const sourceData = {
        year: date.getFullYear(),
        month: date.getMonth(),
        day: date.getDate(),
      };

      const targetData = {
        year: sourceData.month === 11 ? sourceData.year + 1 : sourceData.year,
        month: sourceData.month === 11 ? 0 : sourceData.month + 1,
        day: 1
      };
      const retDate = new Date();
      retDate.setFullYear(targetData.year);
      retDate.setMonth(targetData.month);
      retDate.setDate(targetData.day);
      retDate.setHours(0);
      retDate.setMinutes(0);
      retDate.setSeconds(0);
      const ms = retDate.getTime() - 1 * 1000;
      return new Date(ms);
    },
    fixZero(num) {
      const number = Number(num);
      return number > 9 ? `${number}` : `0${number}`;
    },
    fixMonth(row) {
      const { year, month } = row;
      const fixMonth = this.fixZero(month);
      return [year, fixMonth].join('.');
    },
    getTableListReqData() {
      const ret = {
        ...this.formSearch
      };

      const dataMonth = this.monthRangeFormat;
      if (dataMonth && dataMonth.length) {
        const dataMonthStartTime = dataMonth[0];
        const dataMonthEndTime = dataMonth[1];
        ret.dataMonthStartTime = dataMonthStartTime;
        ret.dataMonthEndTime = dataMonthEndTime;
      }

      delete ret.monthrange;

      return ret;
    },
    // 获取列表
    getTableList: function () {
      const reqData = this.getTableListReqData();
      this.$getJSON(apis.simDataMonthPage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.network-flow-used-record {
}
</style>
